(() => {
  const initSection = (section) => {
    if (!section?.classList.contains('recommended-slider-section')) return;
    const box = section.querySelector('.recommended-slider');
    const slider = section.querySelector('.recommended-slider__slider .swiper');
    if (!box || !slider || typeof Swiper === 'undefined') return;
    if (slider.swiper) slider.swiper.destroy(true, true);
    const slides = slider.querySelectorAll('.swiper-slide').length;
    const desktop = Number(box.dataset.slidesDesktop || 3);
    const autoplay = box.dataset.autoplay === 'true' && slides > 1;
    const swiper = new Swiper(slider, {
      speed: Number(box.dataset.speed || 1) * 1000,
      loop: box.dataset.loop === 'true' && slides > desktop,
      autoplay: autoplay ? { delay: Number(box.dataset.delay || 3) * 1000, pauseOnMouseEnter: box.dataset.stopAutoplay === 'true', disableOnInteraction: false } : false,
      slidesPerView: Number(box.dataset.slidesMobile || 1.5),
      spaceBetween: Number(box.dataset.spaceMobile || 16),
      mousewheel: { forceToAxis: true },
      breakpoints: {
        750: { slidesPerView: Number(box.dataset.slidesTablet || 2), spaceBetween: Number(box.dataset.spaceTablet || 20) },
        1360: { slidesPerView: desktop, spaceBetween: Number(box.dataset.spaceDesktop || 24) }
      },
      navigation: { nextEl: section.querySelector('.swiper-button-next'), prevEl: section.querySelector('.swiper-button-prev') },
      pagination: { el: section.querySelector('.recommended-slider__pagination'), clickable: true }
    });
    requestAnimationFrame(() => swiper.update());
  };
  const initAll = () => document.querySelectorAll('.recommended-slider-section').forEach(initSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', (event) => initSection(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('.recommended-slider__slider .swiper')?.swiper?.destroy(true, true));
})();
